import React, { useEffect } from "react";
import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Flex,
  Icon,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { MdLocationOn, MdPeople } from "react-icons/md";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import ProfileUsers from "../tab_panels/ProfileUsers";
import PrivateLocations from "../tab_panels/PrivateLocations";
import StationsPricing from "../tab_panels/StationsPricing";

const UserProfileTabs = ({ profileData }) => {
  const [activeTabIndex, setActiveTabIndex] = React.useState(0);
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const textColor = useColorModeValue("gray.700", "white");

  const clickHandler = (path) => {
    navigate(`/admin/userprofiles/view/${id}?tab=${path}`);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get("tab");

    if (tab === "users" || !tab) {
      setActiveTabIndex(0);
    } else if (tab === "pricing") {
      setActiveTabIndex(1);
    } else if (tab === "private-locations") {
      setActiveTabIndex(2);
    }
  }, [location.search, id]);

  // Redirect to users tab by default
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get("tab");

    if (!tab) {
      navigate(`/admin/userprofiles/view/${id}?tab=users`, { replace: true });
    }
  }, [location.search, id, navigate]);

  return (
    <Tabs variant="unstyled" isLazy index={activeTabIndex}>
      <VStack align="start" spacing={2}>
        <Text fontSize="2xl" fontWeight="bold" color={textColor}>
          {profileData?.Name || "Loading..."}
        </Text>
        <Text fontSize="sm" color="gray.500">
          Contract ID: {profileData?.ContractId || "N/A"}
        </Text>
      </VStack>
      <TabList
        gap={4}
        px={1}
        py={2}
        bg="rgba(255, 255, 255, 0.6)"
        backdropFilter="blur(12px)"
        borderRadius="xl"
        border="1px solid rgba(35, 169, 121, 0.15)"
        position="relative"
        overflow="hidden"
        _before={{
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "100%",
          zIndex: 0,
          pointerEvents: "none",
        }}
      >
        <Tab
          _focus={{ boxShadow: "none" }}
          onClick={() => clickHandler("users")}
          borderRadius="lg"
          px={4}
          py={2}
          fontWeight="500"
          color="gray.600"
          position="relative"
          zIndex="1"
          _selected={{
            bg: "rgba(35, 169, 121, 0.15)",
            color: "brand.500",
            fontWeight: "600",
            boxShadow: "0 2px 4px rgba(35, 169, 121, 0.1)",
          }}
          _hover={{
            bg: "rgba(35, 169, 121, 0.08)",
            color: "brand.500",
          }}
        >
          <Flex align="center" gap={2}>
            <Icon as={MdPeople} boxSize={4} />
            <Text>Users</Text>
          </Flex>
        </Tab>
        <Tab
          _focus={{ boxShadow: "none" }}
          onClick={() => clickHandler("pricing")}
          borderRadius="lg"
          px={4}
          py={2}
          fontWeight="500"
          color="gray.600"
          position="relative"
          zIndex="1"
          _selected={{
            bg: "rgba(35, 169, 121, 0.15)",
            color: "brand.500",
            fontWeight: "600",
            boxShadow: "0 2px 4px rgba(35, 169, 121, 0.1)",
          }}
          _hover={{
            bg: "rgba(35, 169, 121, 0.08)",
            color: "brand.500",
          }}
        >
          <Flex align="center" gap={2}>
            <Text fontSize="lg" fontWeight="bold">
              ₹
            </Text>
            <Text>Pricing</Text>
          </Flex>
        </Tab>
        <Tab
          _focus={{ boxShadow: "none" }}
          onClick={() => clickHandler("private-locations")}
          borderRadius="lg"
          px={4}
          py={2}
          fontWeight="500"
          color="gray.600"
          position="relative"
          zIndex="1"
          _selected={{
            bg: "rgba(35, 169, 121, 0.15)",
            color: "brand.500",
            fontWeight: "600",
            boxShadow: "0 2px 4px rgba(35, 169, 121, 0.1)",
          }}
          _hover={{
            bg: "rgba(35, 169, 121, 0.08)",
            color: "brand.500",
          }}
        >
          <Flex align="center" gap={2}>
            <Icon as={MdLocationOn} boxSize={4} />
            <Text>Private locations</Text>
          </Flex>
        </Tab>
      </TabList>

      <TabPanels>
        <TabPanel px={0} py={4}>
          <ProfileUsers profileId={id} pData={profileData} />
        </TabPanel>
        <TabPanel px={0} py={4}>
          <StationsPricing id={id} />
        </TabPanel>
        <TabPanel px={0} py={4}>
          <PrivateLocations id={id} />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

export default UserProfileTabs;
